export interface IOptions {
  startTime: string | number;
  endTime: string | number;
  startTimeWeekend?: string | number;
  endTimeWeekend?: string | number;
  days?: string; // days = "0,3,4" Sunday is 0, Monday is 1, and so on.
  schedule?: string; // schedule = "3;10:00-20:00,4;11:00-23:00"
}

export function displayTimeRestrictedWidget(options: IOptions): boolean {
  const {
    days,
    schedule,
    startTimeWeekend,
    endTimeWeekend,
    startTime,
    endTime,
  } = options;

  const hasGeneralTimes = !!(startTime && endTime);
  const hasWeekendTimes = !!(startTimeWeekend && endTimeWeekend);

  const today = new Date();

  if (days && !withinDayRange(days, today)) {
    return false;
  }

  if (schedule) {
    //schedule '3;10:00-20:00,3;21:00-22:00,4;11:00-23:00';
    const matchingSchedule = options.schedule
      ?.split(',')
      .filter((i) => parseInt(i[0]) === today.getDay())
      ?.map((element) => element.split(';')[1])
      ?.map((element) => element.split('-'));

    if (matchingSchedule && matchingSchedule.length > 0) {
      return matchingSchedule.some((schedule) =>
        displayTimeRestrictedWidget({
          startTime: schedule[0],
          endTime: schedule[1],
        }),
      );
    } else {
      return false;
    }
  }

  if (hasGeneralTimes || hasWeekendTimes) {
    if (hasWeekendTimes) {
      const day = today.getDay();
      const isWeekend = !(day % 6);
      // override general times if it's the weekend
      if (isWeekend) {
        return internalValidTimeRange(
          today,
          dateStringToNumber(startTimeWeekend),
          dateStringToNumber(endTimeWeekend),
        );
      }
    }
    if (hasGeneralTimes) {
      return internalValidTimeRange(
        today,
        dateStringToNumber(startTime),
        dateStringToNumber(endTime),
      );
    }

    return false; // fallthrough
  }

  return true;
}

function internalValidTimeRange(
  today: Date,
  start: number,
  end: number,
): boolean {
  const hoursNow = today.getHours() + today.getMinutes() / 60;

  // check for time windows that spread over a day
  return start < end
    ? start < hoursNow && hoursNow < end
    : hoursNow < end || hoursNow > start;
}

function withinDayRange(days: string, day: Date) {
  const dayNumber = day.getDay();

  return days?.indexOf(dayNumber.toString()) >= 0;
}

function dateStringToNumber(dateString: string | number): number {
  if (typeof dateString === 'string') {
    const dateBroken = [...dateString.split(':')].map((i) =>
      Number.parseInt(i),
    );

    return dateBroken[0] + dateBroken[1] / 60;
  }

  return dateString;
}

export function validTimeRange(
  startDate: string | number,
  endDate: string | number,
): boolean {
  const now = new Date();
  const start = new Date(startDate ? startDate : '1970-01-01T00:00:00Z');
  const end = new Date(endDate ? endDate : '2030-12-31T23:59:59Z');

  return now > start && now < end;
}
